module.exports = __webpack_public_path__ + "img/emeishantuanjian.a3937eee.png";